// Tiptap Image Resize Extension
// ref:https://github.com/bae-sh/tiptap-extension-resize-image/blob/main/lib/imageResize.ts
// styleからcursor: pointer;を外したい & heightをautoにするためextendしている
// また、サイズ変更を%指定に変更している

// eslint-disable-next-line import/no-named-as-default
import ImageResize from "tiptap-extension-resize-image";

// サイズを自由に変更できるコントローラーの表示をするかどうか
const EnableDotController = false;

export default ImageResize.extend({
  addAttributes() {
    return {
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      style: {
        default: "width: 100%; height: auto;",
      },
    };
  },

  addNodeView() {
    return ({ node, editor, getPos }) => {
      const {
        view,
        options: { editable },
      } = editor;
      const { src, alt, style } = node.attrs;
      const $img = document.createElement("img");

      $img.setAttribute("src", src);
      $img.setAttribute("alt", alt);
      $img.setAttribute("style", style);

      if (!editable) return { dom: $img };

      const $container = document.createElement("div");
      $container.appendChild($img);

      const dotsPosition = [
        "top: -4px; left: -4px; cursor: nwse-resize;",
        "top: -4px; right: -4px; cursor: nesw-resize;",
        "bottom: -4px; left: -4px; cursor: nesw-resize;",
        "bottom: -4px; right: -4px; cursor: nwse-resize;",
      ];

      let isResizing = false;
      let startX: number, startWidth: number;

      $container.addEventListener("click", () => {
        $container.setAttribute(
          "style",
          `position: relative; border: 1px dashed #6C6C6C; cursor: pointer;`,
        );

        if (EnableDotController) {
          // サイズを自由に変更できるコントローラーの表示
          for (let index = 0; index < 4; index++) {
            const $dot = document.createElement("div");
            $dot.setAttribute(
              "style",
              `position: absolute; width: 9px; height: 9px; border: 1.5px solid #6C6C6C; border-radius: 50%; ${dotsPosition[index]}`,
            );

            $dot.addEventListener("mousedown", e => {
              e.preventDefault();
              isResizing = true;
              startX = e.clientX;
              startWidth = $container.offsetWidth;

              const onMouseMove = (e: MouseEvent) => {
                if (!isResizing) return;

                const deltaX = e.clientX - startX;

                const newWidth = startWidth + deltaX;

                $container.style.width = newWidth + "px";
                $container.style.height = "auto";

                $img.style.width = newWidth + "px";
                $img.style.height = "auto";
              };

              const onMouseUp = () => {
                if (isResizing) {
                  isResizing = false;
                }
                if (typeof getPos === "function") {
                  const newAttrs = {
                    ...node.attrs,
                    style: `${$img.style.cssText}`,
                  };
                  view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, newAttrs));
                }

                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
              };

              document.addEventListener("mousemove", onMouseMove);
              document.addEventListener("mouseup", onMouseUp);
            });
            $container.appendChild($dot);
          }
        }

        // スケールボタン
        const $scaleButtons = document.createElement("div");
        $scaleButtons.setAttribute(
          "style",
          "position: absolute; bottom: 0px; right: 0px; background-color: transparent; display:flex;",
        );
        for (const scale of ["25%", "50%", "75%", "100%"]) {
          const $scale100Button = document.createElement("div");
          const backgroundColor = $img.style.width === scale ? "#119CF6" : "#333333";
          $scale100Button.setAttribute(
            "style",
            `background-color: ${backgroundColor}; color: white; text-align: center; line-height: 20px; cursor: pointer; margin: 2px 4px; padding: 4px 10px; border-radius: 4px;`,
          );

          $scale100Button.addEventListener("click", event => {
            event.stopPropagation();

            $img.style.width = scale;
            $img.style.height = "auto";
            if (typeof getPos === "function") {
              const newAttrs = {
                ...node.attrs,
                style: `${$img.style.cssText}`,
              };
              view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, newAttrs));
            }
          });
          $scale100Button.innerHTML = scale;
          $scaleButtons.appendChild($scale100Button);
        }
        $container.appendChild($scaleButtons);
      });

      document.addEventListener("click", (e: MouseEvent) => {
        if (!$container.contains(e.target as Node)) {
          $container.removeAttribute("style");
          while ($container.childElementCount > 1) {
            $container.removeChild($container.lastChild);
          }
          while ($img.childElementCount > 1) {
            $img.removeChild($img.lastChild);
          }
        }
      });

      return {
        dom: $container,
      };
    };
  },
});
